import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const BG = "/altamura-cattedrale.jpg";

export default function Login() {
  const { setUser } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [temp, setTemp] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      if (temp) {
        const { data } = await api.post("/auth/2fa/verify", { code, temp_token: temp });
        setUser(data);
      } else {
        const { data } = await api.post("/auth/login", { email, password });
        if (data.requires_2fa) setTemp(data.temp_token);
        else setUser(data);
      }
    } catch (err) {
      setError(errMsg(err));
      toast.error(errMsg(err));
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="relative hidden lg:block grain">
        <img src={BG} alt="Cattedrale di Altamura" className="absolute inset-0 h-full w-full object-cover object-top" data-testid="login-bg-image" />
        <div className="absolute inset-0 bg-stone-900/40" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <img src="/logo-dimori.svg" alt="Dimori Guest House" className="h-28 w-28 rounded-2xl mb-6 shadow-lg" />
          <p className="font-display text-5xl font-extrabold leading-tight">Ospiti accolti,<br />obblighi in ordine.</p>
          <p className="mt-4 text-white/80 max-w-md">Check-in online, schedine Alloggiati Web e movimentazione ISTAT per il DMS Puglia in un unico posto.</p>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-12">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6 fade-up" data-testid="login-form">
          <div>
            <img src="/logo-dimori.svg" alt="Dimori Guest House" className="h-20 w-20 rounded-2xl mb-4 lg:hidden" data-testid="login-logo" />
            <p className="font-display text-3xl font-extrabold">Dimori Guest House</p>
            <p className="text-sm text-stone-500 mt-1">{temp ? "Inserisci il codice dell'app di autenticazione" : "Accedi all'area gestione"}</p>
          </div>
          {!temp ? (
            <>
              <div className="space-y-1.5">
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" className="h-11" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email-input" />
              </div>
              <div className="space-y-1.5">
                <Label htmlFor="password">Password</Label>
                <Input id="password" type="password" className="h-11" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password-input" />
              </div>
            </>
          ) : (
            <div className="space-y-1.5">
              <Label htmlFor="code">Codice a 6 cifre</Label>
              <Input id="code" inputMode="numeric" className="h-11 font-mono tracking-[0.4em] text-center text-lg" value={code} onChange={(e) => setCode(e.target.value)} autoFocus data-testid="login-2fa-input" />
            </div>
          )}
          {error && <p className="text-sm text-rose-700" data-testid="login-error">{error}</p>}
          <Button type="submit" className="w-full h-11" disabled={loading} data-testid="login-submit-button">{loading ? "Accesso…" : temp ? "Verifica" : "Accedi"}</Button>
        </form>
      </div>
    </div>
  );
}
